const fonts = {
  normal: 'Montserrat-Medium',
  bold: 'Montserrat-SemiBold',
};

export default fonts;
